import state from './state/index'
import getters from './getters/index'
import mutations from './mutations/index'
import actions from './actions/index'
export default {
  state,
  getters,
  mutations,
  actions
}
